import React from "react";
import Error from "../../assets/svg/Error.svg";

const SessionExpired = () => {
  return (
    <div className="installation-container">
      <header style={{ padding: "20px" }} className="header">
        <div className="flex items-center gap-2">
          <a href="/salesforce/setup" className="magic-logo">
            <img
              src="https://sm-icon-assets.s3.us-east-1.amazonaws.com/sms-magic-logo.svg"
              alt="logo"
              style={{ height: "24px", width: "143.3px" }}
            ></img>
          </a>
        </div>
      </header>
      <main className="main-content">
        <div className="icon-container">
          <img
            src={Error}
            alt="No User Found"
            className="icon-sms"
            style={{ width: "48px", height: "48px" }}
          />
        </div>
        <div
          className="installation-text"
          style={{ marginBottom: "0px", marginTop: "0px" }}
        >
          <h1 className="title">Session Expired</h1>
          <p className="subtitle-magic">
            Your session has expired due to inactivity.
          </p>
        </div>
      </main>
    </div>
  );
};

export default SessionExpired;
